// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banksList__item[data-v-01664e76]{color:#010d35;font-size:15px;font-weight:500;line-height:20px;margin-bottom:20px}.banksList__item-label[data-v-01664e76]{margin-bottom:16px}.banksList__item-inner[data-v-01664e76]{align-items:center;cursor:pointer;display:flex;height:40px}.banksList__item-inner[data-v-01664e76]:not(:last-child){margin-bottom:4px}.banksList__item-ico[data-v-01664e76]{height:24px;margin-right:8px;width:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
